import * as React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";

import CodeInput from "react-native-confirmation-code-input";
import { currentLanguage } from "../../../translations/CurrentLanguage";

import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import AuthCard from "@components/AuthCardComponent";
import translation from "../../../translations/translation";
import LocalizedStrings from "react-native-localization";
import { colors, radius } from "../../../theme/modern";

let strings = new LocalizedStrings(translation);

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "", "0", "back"];

class Pin extends React.Component {
  onSelect(attendant, index) {
    Promise.resolve(this.props.onAttendantChange(attendant._id, index)).then(
      () => this.props.onNext(),
    );
  }

  onKey(key) {
    if (!this.code) {
      return;
    }
    if (key === "back") {
      this.code.backspace();
    } else {
      this.code.press(key);
    }
  }

  renderDemoHint() {
    // demo installs show the available logins
    const demo = typeof window !== "undefined" ? window.__DEVPOS_DEMO__ : null;
    if (!demo) {
      return null;
    }
    return (
      <View style={styles.demo}>
        <Text style={styles.demoTitle}>Demo logins</Text>
        {demo.logins.map(login => (
          <Text key={login.name} style={styles.demoText}>
            {`${login.name} (${login.role}): PIN ${login.pin}`}
          </Text>
        ))}
      </View>
    );
  }

  renderAttendants() {
    return (
      <AuthCard title={strings.SelectAttendant} footer={this.renderDemoHint()}>
        {this.props.attendants.map((attendant, index) => (
          <TouchableOpacity
            key={attendant._id}
            activeOpacity={0.7}
            style={styles.attendant}
            onPress={() => this.onSelect(attendant, index)}
          >
            <View style={styles.avatar}>
              <Text style={styles.avatarText}>
                {attendant.user_name.charAt(0).toUpperCase()}
              </Text>
            </View>
            <View style={styles.attendantText}>
              <Text style={styles.attendantName} numberOfLines={1}>
                {attendant.user_name}
              </Text>
              <Text style={styles.attendantRole} numberOfLines={1}>
                {attendant.role}
              </Text>
            </View>
            <Icon name="chevron-right" size={22} color={colors.textFaint} />
          </TouchableOpacity>
        ))}
      </AuthCard>
    );
  }

  renderPin() {
    const attendant = this.props.attendants.find(
      row => row._id === this.props.currentAttendant,
    );
    return (
      <AuthCard
        title={strings.EnterPin}
        subtitle={attendant ? attendant.user_name : null}
        footer={this.renderDemoHint()}
      >
        <View style={styles.code}>
          <CodeInput
            ref={code => {
              this.code = code;
            }}
            size={52}
            space={10}
            codeLength={4}
            secureTextEntry
            autoFocus={true}
            ignoreCase={true}
            compareWithCode={this.props.code}
            codeInputStyle={styles.codeInput}
            containerStyle={styles.codeContainer}
            activeColor={colors.primary}
            inactiveColor="#d5dbe5"
            onFulfill={isValid => this.props.onFulfill(isValid)}
          />
        </View>
        <View style={styles.keypad}>
          {KEYS.map(
            (key, index) =>
              key === "" ? (
                <View key={index} style={styles.keySpace} />
              ) : (
                <TouchableOpacity
                  key={index}
                  activeOpacity={0.6}
                  style={styles.key}
                  onPress={() => this.onKey(key)}
                >
                  {key === "back" ? (
                    <Icon name="backspace" size={22} color={colors.textMuted} />
                  ) : (
                    <Text style={styles.keyText}>{key}</Text>
                  )}
                </TouchableOpacity>
              ),
          )}
        </View>
        <TouchableOpacity
          activeOpacity={0.7}
          style={styles.back}
          onPress={() => this.props.onBack && this.props.onBack()}
        >
          <Icon name="chevron-left" size={18} color={colors.primary} />
          <Text style={styles.backText}>{strings.SelectAttendant}</Text>
        </TouchableOpacity>
      </AuthCard>
    );
  }

  render() {
    strings.setLanguage(currentLanguage().companyLanguage);
    return this.props.selected ? this.renderPin() : this.renderAttendants();
  }
}

const styles = StyleSheet.create({
  attendant: {
    flexDirection: "row",
    alignItems: "center",
    padding: 12,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: colors.border,
    borderRadius: radius.medium,
    backgroundColor: colors.surface,
  },
  avatar: {
    width: 42,
    height: 42,
    borderRadius: 21,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.primarySoft,
  },
  avatarText: {
    fontSize: 16,
    fontWeight: "700",
    color: colors.primary,
  },
  attendantText: {
    flex: 1,
    marginLeft: 12,
  },
  attendantName: {
    fontSize: 15,
    fontWeight: "700",
    color: colors.text,
  },
  attendantRole: {
    marginTop: 1,
    fontSize: 13,
    color: colors.textMuted,
  },
  code: {
    alignItems: "center",
  },
  codeContainer: {
    marginTop: 0,
  },
  codeInput: {
    borderWidth: 2,
    backgroundColor: "#f8fafc",
  },
  keypad: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignSelf: "center",
    width: 264,
    marginTop: 24,
  },
  key: {
    width: 80,
    height: 56,
    marginBottom: 10,
    borderRadius: radius.medium,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f1f5f9",
  },
  keySpace: {
    width: 80,
    height: 56,
    marginBottom: 10,
  },
  keyText: {
    fontSize: 22,
    fontWeight: "600",
    color: colors.text,
  },
  back: {
    flexDirection: "row",
    alignItems: "center",
    alignSelf: "center",
    marginTop: 10,
    paddingVertical: 6,
    paddingHorizontal: 10,
  },
  backText: {
    marginLeft: 2,
    fontSize: 14,
    fontWeight: "600",
    color: colors.primary,
  },
  demo: {
    alignItems: "center",
    marginTop: 22,
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: radius.medium,
    backgroundColor: "rgba(37, 99, 235, 0.07)",
  },
  demoTitle: {
    marginBottom: 4,
    fontSize: 12,
    fontWeight: "700",
    letterSpacing: 0.5,
    textTransform: "uppercase",
    color: colors.primary,
  },
  demoText: {
    fontSize: 13,
    lineHeight: 19,
    color: "#475569",
  },
});

export default Pin;
